export class Card {
    constructor({
        data,
        templateSelector,
        userId,
        handleCardClick,
        handleCardLikes,
        handleDeleteIconClick,
    })
    {
        this._name = data.name;
        this._link = data.link;
        this._likes = data.likes;
        this._ownerId = data.owner._id;
        this._id = data._id;
        this._isUserCard = userId === data.owner._id;
        this._templateSelector = templateSelector;
        this._handleCardClick = handleCardClick;
        this._handleCardLikes = handleCardLikes;
        this._handleDeleteIconClick = handleDeleteIconClick;
        this._userId = userId;
        this._buttonRemoveCard = document.querySelector('.card__remove-btn');
    }

    _getTemplate() {
        const cardElement = document.
            querySelector(this._templateSelector)
            .content.querySelector('.card')
            .cloneNode(true);
        return cardElement;
    }
    // Method to add likes on images: (addLikesOnCardButton)
    like() {
        this._buttonLikeCard.classList.add('card__like-btn_active');
        this.isLiked = true;
    }
    // Method to remove likes from images: (removeLikesOnCardButton)
    dislike() {
        this._buttonLikeCard.classList.remove('card__like-btn_active');
        this.isLiked = false;
    }
    // Method to count likes on images:
    countingCardLikes(response) {
        this._numberOfLikesHtmlElement.textContent = response;
    }
    // Method to check if user already liked then make it visible:
    _thisUserLiked() {
        if(this._checkIfUserHasLiked()) {
            this.like();
        } else {
            this.dislike();
        }
    }
    // Method to check if user already liked photo:
    _checkIfUserHasLiked() {
        return this._likes.some(item => item._id === this._userId);
    }
    // Method to show/hide trash button:
    _buttonToRemoveCardShowOrHide() {
        if(this._userId !== this._ownerId) {
            this._buttonRemoveCard.classList.add('card__remove-btn_disable')
        }
    }
    // Method to find and return card id:
    getCardId() {
        return this._id;
    }
    removeCard() {
        this._element.remove();
        this._element = null;
    }
    // Private listeners:
    _setEventListeners() {
        // click on trash button to remove card:
        if(this._isUserCard) {
            this._element.querySelector('.card__remove-btn').addEventListener('click', () => {
                this._handleDeleteIconClick(this)
            })
        }
        // click on card to zoom-in
        this._cardImage.addEventListener('click', () => {
            this._handleCardClick(this._name, this._link)
        })
        // click on like/dislike button:
        this._buttonLikeCard.addEventListener('click', this._handleCardLikes)

    }

    generateCard() {
        this._element = this._getTemplate();
        
        this._cardImage = this._element.querySelector('.card__image');
        this._cardHeading = this._element.querySelector('.card__title');
        this._cardImage.setAttribute('src', this._link);
        this._cardImage.setAttribute('alt', this._name);
        this._cardHeading.textContent = this._name;

        this._buttonLikeCard = this._element.querySelector('.card__like-btn');
        this._numberOfLikes = this._element.querySelector('.card__likes_count');
        this._buttonRemoveCard = this._element.querySelector('.card__remove-btn');
        this._numberOfLikesHtmlElement = this._element.querySelector('.card__likes_count');

        this._setEventListeners();
        this._buttonToRemoveCardShowOrHide();
        this.countingCardLikes(this._likes.length);
        this._thisUserLiked();

        return this._element;
    }
}